export default "__VITE_ASSET__DyFnwd2E__"